import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';
import { connect, useSelector } from 'react-redux';
import { Box, Text } from '@cubeyou-team/hx-react-components';
import {
  addConversationItemRequest,
  itemDragToggle,
} from '../../actions';
import { findSelectedGroup } from '../../operations/query';

const getIsDragging = props => {
  if (!props.isDragging) {
    return false;
  }

  return css`
    border-left: 3px solid ${props => props.theme.colors.secondary};
  `;
};

const StyledCoversationListItem = styled.div`
  align-items: center;
  position: relative;
  padding-left: ${props => props.theme.spacing.medium};
  padding-right: ${props => props.theme.spacing.medium};
  padding-top: ${props => props.theme.spacing.small};
  padding-bottom: ${props => props.theme.spacing.small};
  border-radius: ${props => props.theme.border_radius.standard};
  background-color: transparent;
  cursor: pointer;
  height: 48px;
  display: flex;

  ${props => getIsDragging(props)}

  &:focus, &:hover {
    background-color: white;
  }

  & div {
    padding-bottom: 0px;
  }
`;

const CoversationExplorerListItem = ({
  item,
  itemDragToggle,
  addConversationItemRequest,
}) => {
  const targetId = useSelector(state => state.queryBuilder.target_selected);
  const targetQuery = useSelector(
    state => state.queryBuilder.targets[targetId]?.target_query
  );
  const [isDragging, SetIsDragging] = useState(false);

  const handleDoubleClick = useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();

      if (!targetId) {
        return;
      }

      const groupId = targetQuery ? findSelectedGroup(targetQuery) : null;
      addConversationItemRequest(targetId, groupId || 0, item);
    },
    [addConversationItemRequest, item, targetId, targetQuery]
  );

  return (
    <React.Fragment>
      <StyledCoversationListItem
        key={item.id}
        draggable
        isDragging={isDragging}
        onDragStart={e => {
          SetIsDragging(true);
          itemDragToggle(true);
          e.dataTransfer.setData('itemId', item.id);
          e.dataTransfer.setData('itemInfos', JSON.stringify(item));
        }}
        onDragEnd={() => {
          SetIsDragging(false);
          itemDragToggle(false);
        }}
        data-item-id={item.id}
      >
        <Box pB="large" minWidth="100%" onDoubleClick={handleDoubleClick}>
          <Text align="left" variant="dark" weight="bold" size="small">
            {item.query}
          </Text>
        </Box>
      </StyledCoversationListItem>
    </React.Fragment>
  );
};

const mapDispatchToProps = {
  itemDragToggle,
  addConversationItemRequest,
};

export default connect(null, mapDispatchToProps)(CoversationExplorerListItem);
